import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import MenuIcon from '../../assets/svg/MenuSvg';
import logo from '../../assets/img/logo.png';

const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <nav className='w-full fixed bg-main z-50'>
        <div className='flex items-center justify-between container'>
          <NavLink to={`/`} className='outline-none my-4'>
            <img className='w-[140px]' src={logo} alt="Logo" />
          </NavLink>

          <button className="lg:hidden text-[24px] cursor-pointer" onClick={toggleSidebar}>
            <MenuIcon/>
          </button>

          <ul className='hidden lg:flex gap-8 items-center'>
            <li className="text-[18px] text-white hover:text-purple font-semibold ease-in-out duration-200">
              <NavLink to={`/`}>Əsas</NavLink>
            </li>
            <li className="text-[18px] text-white hover:text-purple font-semibold ease-in-out duration-200">
              <NavLink to={`/films`}>Seanslar</NavLink>
            </li>
            <li className="text-[18px] text-white hover:text-purple font-semibold ease-in-out duration-200">
              <NavLink to={`/about-us`}>Haqqımızda</NavLink>
            </li>
            <li className="text-[18px] text-white hover:text-purple font-semibold ease-in-out duration-200">
              <NavLink to={`/contact`}>Əlaqə</NavLink>
            </li>
          </ul>
        </div>
      </nav>

      {/* Сайдбар для мобильных устройств */}
      <div
        className={`fixed top-0 left-0 w-[250px] h-full bg-main shadow-lg transform transition-transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} z-40`}
      >
        <ul className='flex flex-col gap-4 p-4 mt-20'>
          <li className="text-[18px] text-white font-semibold">
            <NavLink to={`/`} onClick={toggleSidebar}>Əsas</NavLink>
          </li>
          <li className="text-[18px] text-white font-semibold">
            <NavLink to={`/films`} onClick={toggleSidebar}>Seanslar</NavLink>
          </li>
          <li className="text-[18px] text-white font-semibold">
            <NavLink to={`/about-us`} onClick={toggleSidebar}>Haqqımızda</NavLink>
          </li>
          <li className="text-[18px] text-white font-semibold">
            <NavLink to={`/contact`} onClick={toggleSidebar}>Əlaqə</NavLink>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;